import RestService from '@/api/rest-service/index'

// export class DataService extends RestService {}

export { RestService as DataService }

export class PublisherService extends RestService {
  getPublisherSubscriptions(params) {
    return this.makeRequest('get', `${this.namespace}/${params.id}/subscriptions`)
  }

  getPublisherLicenses(params) {
    let q = this.makeRequestParams(params.context)
    let url = q ? `${this.namespace}/${params.id}/licenses?${q}` : `${this.namespace}/${params.id}/licenses`
    return this.makeRequest('get', url)
  }
}

export class ProviderService extends RestService {
  getProviderAddresses(params) {
    let q = this.makeRequestParams(params.context)
    let url = `${this.namespace}/${params.id}?${q}`
    return this.makeRequest('get', url)
  }
}
export class ImportsService extends RestService {
  parse(params) {
    return this.makeRequest('post', `${this.namespace}/parse`, params.data)
  }

  process(params) {
    return this.makeRequest('post', `${this.namespace}/process`, params.data)
  }

  preview(params) {
    return this.makeRequest('put', `${this.namespace}/preview/rows/${params.id}`, params.value)
  }
}

export class ProgressBarService extends RestService {
  getTaskCount(params) {
    let url = params.entity
      ? `${this.namespace}/tasks/count/${params.namespace}/${params.entity.namespace}/${params.entity.id}`
      : `${this.namespace}/tasks/count/${params.namespace}`
    return this.makeRequest('get', url)
  }

  getTaskSettings(params) {
    return this.makeRequest('get', `${this.namespace}/settings/${params.namespace}`)
  }

  getTaskSettingsData(params) {
    return this.makeRequest('get', `${this.namespace}/settings/data/${params.namespace}`)
  }

  getTaskData(params) {
    let url = params.entity
      ? `${this.namespace}/tasks/data/${params.namespace}/${params.entity.namespace}/${params.entity.id}`
      : `${this.namespace}/tasks/data/${params.namespace}`
    return this.makeRequest('get', url)
  }

  getQuickviewData(params) {
    return this.makeRequest('get', `${this.namespace}/tasks/quick-view/${params.namespace}/${params.id}`)
  }

  dismiss(params) {
    let data = params.data ? params.data : null
    return this.makeRequest('post', `${this.namespace}/tasks/dismiss/${params.namespace}/${params.id}`, data)
  }

  process(params) {
    let data = params.data ? params.data : params.value
    return this.makeRequest('post', `${this.namespace}/tasks/process/${params.namespace}/${params.id}`, data)
  }
}

export class SubscriptionPeriodService extends RestService {
  createNewSubscriptionPeriod(params) {
    return this.makeRequest('post', `${this.namespace}/${params.id}/create-new-period`, null)
  }

  cancel(params) {
    return this.makeRequest('get', `${this.namespace}/${params.id}/cancel`)
  }

  accept(params) {
    return this.makeRequest('get', `${this.namespace}/${params.id}/accept`)
  }
}

export class FormsService extends RestService {
  exists(params) {
    return this.makeRequest('get', `${this.namespace}/exists?${this.makeRequestParams(params)}`)
  }
}
